export default __webpack_public_path__ + "static/PlantEmpower-Features-9e15f4f04d25c0f540a4f97982f896f8.jpeg";